export const DEFAULT_CONTEXT_STATE = [undefined, () => {}] as [
  undefined,
  () => {}
]
